import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Man4Icon(props: IconProps) {
    return <Icon {...props} iconKey={"man_4"}/>
}
